import React, { useState } from 'react';
import '../styles/AddStreamModal.css';

const ViewStreamModal = ({ isOpen, onClose, stream }) => {
  const [copied, setCopied] = useState(false);

  if (!isOpen || !stream) return null;

  const handleCopyLink = () => {
    const shareUrl = `${window.location.origin}/stream/${stream.id}`;
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleShareSocial = (platform) => {
    const shareUrl = `${window.location.origin}/stream/${stream.id}`;
    const title = `Check out this stream: ${stream.stream_name}`;
    let url = '';

    switch (platform) {
      case 'twitter':
        url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(shareUrl)}`;
        break;
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
        break;
      case 'whatsapp':
        url = `https://wa.me/?text=${encodeURIComponent(title + ' ' + shareUrl)}`;
        break;
      default:
        return;
    }

    window.open(url, '_blank', 'width=600,height=400');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content add-stream-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '900px', maxHeight: '90vh', overflowY: 'auto' }}>
        <div className="modal-header">
          <h2>🎬 Stream Details</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <div className="stream-details">
          {/* Video Player Section */}
          <div style={{ marginBottom: '30px', backgroundColor: '#000', borderRadius: '10px', overflow: 'hidden' }}>
            {stream.stream_type === 'live' ? (
              // Live Stream Display
              <div style={{ aspectRatio: '16/9', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#1a1a1a' }}>
                <div style={{ textAlign: 'center', color: '#fff' }}>
                  <div style={{ fontSize: '4rem', marginBottom: '20px' }}>🔴</div>
                  <h3 style={{ margin: '0 0 10px 0' }}>LIVE NOW</h3>
                  <p style={{ margin: '0', fontSize: '0.9rem', opacity: 0.7 }}>Stream is currently live</p>
                  {stream.stream_video_link && (
                    <a
                      href={stream.stream_video_link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: 'inline-block',
                        marginTop: '20px',
                        padding: '10px 20px',
                        backgroundColor: '#667eea',
                        color: 'white',
                        textDecoration: 'none',
                        borderRadius: '5px',
                        fontWeight: 'bold'
                      }}
                    >
                      Watch Now →
                    </a>
                  )}
                </div>
              </div>
            ) : stream.stream_video_link ? (
              // Embedded Video Link
              <div style={{ aspectRatio: '16/9' }}>
                {stream.stream_video_link.includes('youtube') ? (
                  <iframe
                    width="100%"
                    height="100%"
                    src={stream.stream_video_link.replace('watch?v=', 'embed/')}
                    title={stream.stream_name}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{ border: 'none' }}
                  ></iframe>
                ) : (
                  <video
                    width="100%"
                    height="100%"
                    controls
                    autoPlay
                    style={{ backgroundColor: '#000' }}
                  >
                    <source src={stream.stream_video_link} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )}
              </div>
            ) : stream.stream_video_path ? (
              // Local Video File
              <div style={{ aspectRatio: '16/9' }}>
                <video
                  width="100%"
                  height="100%"
                  controls
                  autoPlay
                  style={{ backgroundColor: '#000' }}
                >
                  <source src={stream.stream_video_path} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            ) : (
              // Placeholder
              <div style={{ aspectRatio: '16/9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ textAlign: 'center', color: '#999' }}>
                  <div style={{ fontSize: '3rem', marginBottom: '10px' }}>📺</div>
                  <p>No video source available</p>
                </div>
              </div>
            )}
          </div>

          {/* Stream Information */}
          <div style={{ marginBottom: '25px' }}>
            <h3 style={{ marginTop: '0', marginBottom: '15px', fontSize: '1.5rem' }}>{stream.stream_name}</h3>
            <p style={{ color: '#666', marginBottom: '15px', lineHeight: '1.6' }}>{stream.description}</p>

            {/* Status Badges */}
            <div className="status-badges" style={{ marginBottom: '20px' }}>
              {stream.is_active ? (
                <span className="badge badge-active">✅ Active</span>
              ) : (
                <span className="badge badge-inactive">⭕ Inactive</span>
              )}
              {stream.is_public ? (
                <span className="badge badge-public">🌐 Public</span>
              ) : (
                <span className="badge badge-private">🔒 Private</span>
              )}
              <span className="badge" style={{ backgroundColor: '#667eea', color: 'white' }}>
                {stream.stream_type === 'video' ? '📹 Video' : stream.stream_type === 'audio' ? '🎵 Audio' : stream.stream_type === 'live' ? '🔴 Live' : '🔗 ' + stream.stream_type}
              </span>
            </div>

            {/* Stream Details Grid */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '25px' }}>
              <div style={{ backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '8px' }}>
                <strong style={{ display: 'block', marginBottom: '5px', color: '#333' }}>Created</strong>
                <p style={{ margin: '0', color: '#666', fontSize: '0.9rem' }}>
                  {new Date(stream.created_at).toLocaleDateString()} at {new Date(stream.created_at).toLocaleTimeString()}
                </p>
              </div>
              <div style={{ backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '8px' }}>
                <strong style={{ display: 'block', marginBottom: '5px', color: '#333' }}>Stream Type</strong>
                <p style={{ margin: '0', color: '#666', fontSize: '0.9rem', textTransform: 'capitalize' }}>
                  {stream.stream_type}
                </p>
              </div>
            </div>

            {/* Resource Details */}
            {(stream.stream_video_path || stream.stream_video_link) && (
              <div style={{ backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '8px', marginBottom: '25px' }}>
                <strong style={{ display: 'block', marginBottom: '10px', color: '#333' }}>📂 Resources</strong>
                {stream.stream_video_path && (
                  <p style={{ margin: '5px 0', fontSize: '0.9rem', color: '#666', wordBreak: 'break-all' }}>
                    📁 File: <code style={{ backgroundColor: '#e0e0e0', padding: '2px 5px', borderRadius: '3px' }}>{stream.stream_video_path.split('/').pop()}</code>
                  </p>
                )}
                {stream.stream_video_link && (
                  <p style={{ margin: '5px 0', fontSize: '0.9rem', color: '#666', wordBreak: 'break-all' }}>
                    🔗 Link: <a href={stream.stream_video_link} target="_blank" rel="noopener noreferrer" style={{ color: '#667eea' }}>{stream.stream_video_link}</a>
                  </p>
                )}
              </div>
            )}
          </div>

          {/* Sharing Section */}
          <div style={{ borderTop: '1px solid #e0e0e0', paddingTop: '25px' }}>
            <h4 style={{ marginTop: '0', marginBottom: '15px', fontSize: '1.1rem' }}>📤 Share This Stream</h4>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <button
                onClick={handleCopyLink}
                style={{
                  padding: '10px 15px',
                  backgroundColor: copied ? '#27ae60' : '#667eea',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  transition: 'all 0.3s'
                }}
              >
                {copied ? '✅ Copied!' : '📋 Copy Link'}
              </button>
              <button
                onClick={() => handleShareSocial('twitter')}
                style={{
                  padding: '10px 15px',
                  backgroundColor: '#1DA1F2',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
                title="Share on Twitter"
              >
                𝕏 Twitter
              </button>
              <button
                onClick={() => handleShareSocial('facebook')}
                style={{
                  padding: '10px 15px',
                  backgroundColor: '#1877F2',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
                title="Share on Facebook"
              >
                f Facebook
              </button>
              <button
                onClick={() => handleShareSocial('whatsapp')}
                style={{
                  padding: '10px 15px',
                  backgroundColor: '#25D366',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
                title="Share on WhatsApp"
              >
                💬 WhatsApp
              </button>
            </div>
          </div>

          {/* Close Button */}
          <div style={{ marginTop: '25px', textAlign: 'center' }}>
            <button
              onClick={onClose}
              style={{
                padding: '12px 30px',
                backgroundColor: '#666',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '1rem'
              }}
            >
              ✕ Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewStreamModal;
